import home from "../assets/images/moon.jpg";
import logo from "../assets/images/logo.png";
import { Link } from "react-router-dom";
import { useState } from "react";
import auth from "../firebase";

const UserLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const signIn = (e) => {
    e.preventDefault();

    auth
      .signInWithEmailAndPassword(email, password)
      .catch((error) => alert(error.message));
  };
  return (
    <div
      style={{
        backgroundImage: `url("${home}")`,
        backgroundSize: "cover",
        height: "100vh",
      }}
    >
      <div className="grid place-items-center max-w-md ml-auto mr-auto  pt-28">
        <div className=" p-3">
          <img src={logo} alt="" />
        </div>
        <div className=" bg-gray-800 w-full border border-gray-600 shadow-2xl">
          <div className=" p-4">
            <form className="flex flex-col">
              <label className="text-gray-200 font-semibold text-lg p-1">
                Email address
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="py-2 p-2 border border-gray-600 shadow-2xl rounded-md focus:ring-1 focus:ring-yellow-400 focus:outline-none bg-gray-700 text-gray-200 text-lg font-semibold mb-2"
              />
              <label className="text-gray-200 font-semibold text-lg p-1">
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="py-2 p-2 border border-gray-600 shadow-2xl rounded-md focus:ring-1 focus:ring-yellow-400 focus:outline-none bg-gray-700 text-gray-200 text-lg font-semibold mb-2"
              />
              <div className="mt-8">
                <button
                  onClick={signIn}
                  className=" w-full bg-blue-900 text-base font-semibold focus:outline-none hover:bg-blue-700 text-white py-2"
                >
                  login
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className="mt-5">
          <h1 className=" text-gray-100 font-semibold text-lg">
            Don't have an account?{" "}
            <Link to="/">
              <span className="text-yellow-500 cursor-pointer">Sign up</span>{" "}
            </Link>
          </h1>
        </div>
      </div>
    </div>
  );
};

export default UserLogin;
